import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SettingItem, SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';
import { McpSettingsComponent } from './settings-mcp.component';

export function provideSettingsElementMcpServer(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'mcp-server',
        name: 'MCP Server',
        icon: 'pi pi-server',
        component: McpSettingsComponent,
        order: 3,
        translateName: 'SETTINGS_MCP.TITLE',
        resource_key: 'mcpServerSettings',
        required_action: 'read',
        planLockedBehavior: 'upsell',
        entitlementFeatureKey: 'mcp-access',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'integrations',
          name: 'Integrations',
          order: 2,
          translateName: 'SETTINGS.CATEGORIES.INTEGRATIONS',
        },
      } as SettingItem,
      multi: true,
    },
  ]);
}
